import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type RampVendorFieldsFragment = { __typename?: 'RampVendorData', rampVendorId: string, name: string, isActive: boolean };

export type VendorRampLinkFieldsFragment = { __typename?: 'VendorStateData', id: string, rampVendorId?: string | null, rampVendor?: { __typename?: 'RampVendorData', rampVendorId: string, name: string, isActive: boolean } | null };

export type RampVendorLinkRowsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type RampVendorLinkRowsQuery = { __typename?: 'Query', rampVendorLinkRows: Array<{ __typename?: 'RampVendorLinkRowData', vendorId: string, vendorName: string, rampVendorId?: string | null, rampVendor?: { __typename?: 'RampVendorData', rampVendorId: string, name: string, isActive: boolean } | null, suggestion?: { __typename?: 'RampVendorSuggestionData', tier: Types.RampVendorMatchTier, rampVendor: { __typename?: 'RampVendorData', rampVendorId: string, name: string, isActive: boolean } } | null }> };

export type RampVendorsQueryVariables = Types.Exact<{
  vendorId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type RampVendorsQuery = { __typename?: 'Query', rampVendors: Array<{ __typename?: 'RampVendorData', rampVendorId: string, name: string, isActive: boolean }> };

export type VendorRampLinkQueryVariables = Types.Exact<{
  vendorId: Types.Scalars['String']['input'];
}>;


export type VendorRampLinkQuery = { __typename?: 'Query', vendor?: { __typename?: 'VendorStateData', id: string, rampVendorId?: string | null, rampVendor?: { __typename?: 'RampVendorData', rampVendorId: string, name: string, isActive: boolean } | null } | null };

export const RampVendorFieldsFragmentDoc = new TypedDocumentString(`
    fragment RampVendorFields on RampVendorData {
  rampVendorId
  name
  isActive
}
    `, {"fragmentName":"RampVendorFields"});
export const VendorRampLinkFieldsFragmentDoc = new TypedDocumentString(`
    fragment VendorRampLinkFields on VendorStateData {
  id
  rampVendorId
  rampVendor {
    ...RampVendorFields
  }
}
    fragment RampVendorFields on RampVendorData {
  rampVendorId
  name
  isActive
}`, {"fragmentName":"VendorRampLinkFields"});
export const RampVendorLinkRowsDocument = new TypedDocumentString(`
    query RampVendorLinkRows {
  rampVendorLinkRows {
    vendorId
    vendorName
    rampVendorId
    rampVendor {
      ...RampVendorFields
    }
    suggestion {
      tier
      rampVendor {
        ...RampVendorFields
      }
    }
  }
}
    fragment RampVendorFields on RampVendorData {
  rampVendorId
  name
  isActive
}`);
export const RampVendorsDocument = new TypedDocumentString(`
    query RampVendors($vendorId: String) {
  rampVendors(vendorId: $vendorId) {
    ...RampVendorFields
  }
}
    fragment RampVendorFields on RampVendorData {
  rampVendorId
  name
  isActive
}`);
export const VendorRampLinkDocument = new TypedDocumentString(`
    query VendorRampLink($vendorId: String!) {
  vendor(vendorId: $vendorId) {
    ...VendorRampLinkFields
  }
}
    fragment RampVendorFields on RampVendorData {
  rampVendorId
  name
  isActive
}
fragment VendorRampLinkFields on VendorStateData {
  id
  rampVendorId
  rampVendor {
    ...RampVendorFields
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    RampVendorLinkRows: build.query<RampVendorLinkRowsQuery, RampVendorLinkRowsQueryVariables | void>({
      query: (variables) => ({ document: RampVendorLinkRowsDocument, variables })
    }),
    RampVendors: build.query<RampVendorsQuery, RampVendorsQueryVariables | void>({
      query: (variables) => ({ document: RampVendorsDocument, variables })
    }),
    VendorRampLink: build.query<VendorRampLinkQuery, VendorRampLinkQueryVariables>({
      query: (variables) => ({ document: VendorRampLinkDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useRampVendorLinkRowsQuery, useLazyRampVendorLinkRowsQuery, useRampVendorsQuery, useLazyRampVendorsQuery, useVendorRampLinkQuery, useLazyVendorRampLinkQuery } = injectedRtkApi;
